$(window).load(function(){
	matchHeight();
    testimonial_carousel();
});
$(document).ready(function(){
    matchHeight();
    testimonial_carousel();
});

/*
	Variable Functions ==========================================================
*/

function testimonial_carousel(){
	jQuery('.testimonial-carousel').owlCarousel({
		loop:true,
		nav: true,
		navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
		responsiveClass:true,
		autoplay:true,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		responsive:{

			0:{

				items:1,

			},
			600:{

				items:1,

			},
			1000:{

				items:1,
			}
		}
	})
}


function matchHeight() {
  console.log("matchHeightisWorking");
  jQuery('match').matchHeight();
  jQuery('.col-md-6').matchHeight();
  jQuery('.card__content').matchHeight();
  jQuery('.logo-container h3').matchHeight();
  jQuery('card-information').matchHeight();
}















